import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import {
  SchoolCandidate,
  SchoolCandidateSearch,
  SaveSchoolCandidateInstitutionAssignment,
  SchoolCandidateInstitutionSummarySearch,
  SchoolCandidateInstitutionSummary,
  SchoolCandidateInstitutionAdmin,
  SchoolCandidateInstitutionAdminSearch,
  UpdateSchoolCandidateInstitutionStatus,
  UpdateSchoolCandidateInstitutionCountyAssignment,
  SchoolCandidateRemarkType,
  SchoolCandidateRemark,
  SchoolCandidateResidenceChange,
  SchoolCandidateResidenceChangeSearch,
  SchoolCandidateBatchStatus,
} from "../../models";
import {
  DepartmentScheduleSearch,
  SchoolCandidateDepartmentProgram,
  SyncDataRequest,
} from "../../models/Department";
import { SaveResult } from "../../models/Shared";
const apiUrlPrefix: string = "school-candidates";

export const getStatusList = async () => {
  return api.get(`${apiUrlPrefix}/statuses`) as Promise<CodeBook[]>;
};

export const getSchoolCandidateAddReasonList = async () => {
  return api.get(`${apiUrlPrefix}/add-reasons`) as Promise<CodeBook[]>;
};

export const getSchoolCandidateCancelReasonList = async () => {
  return api.get(`${apiUrlPrefix}/cancel-reasons`) as Promise<CodeBook[]>;
};

export const getSchoolCandidateFilteredList = async (
  schoolCandidateSearch: SchoolCandidateSearch
) => {
  return api.post(`${apiUrlPrefix}`, schoolCandidateSearch) as Promise<
    PagedResult<SchoolCandidate>
  >;
};

export const getSchoolCandidateInstitutionAdminFilteredList = async (
  schoolCandidateInstitutionAdminSearch: SchoolCandidateInstitutionAdminSearch
) => {
  return api.post(
    `${apiUrlPrefix}/institution-admin`,
    schoolCandidateInstitutionAdminSearch
  ) as Promise<PagedResult<SchoolCandidateInstitutionAdmin>>;
};

export const saveInstitutionAssignment = async (
  saveSchoolCandidateInstitutionAssignment: SaveSchoolCandidateInstitutionAssignment
) => {
  return api.post(
    `${apiUrlPrefix}/save-assignment`,
    saveSchoolCandidateInstitutionAssignment
  ) as Promise<SaveResult<SaveSchoolCandidateInstitutionAssignment>>;
};

export const getSchoolCandidateById = async (id: number) => {
  return api.get(`${apiUrlPrefix}/get/${id}`) as Promise<SchoolCandidate>;
};

export const saveSchoolCandidate = async (schoolCandidate: SchoolCandidate) => {
  return api.post(`${apiUrlPrefix}/save`, schoolCandidate) as Promise<
    SaveResult<SchoolCandidate>
  >;
};

export const deleteSchoolCandidate = async (id: number) => {
  return api.delete(`${apiUrlPrefix}/delete/${id}`) as Promise<boolean>;
};

export const searchSchoolCandidateInstitutionSummary = async (
  search: SchoolCandidateInstitutionSummarySearch
) => {
  return api.post(`${apiUrlPrefix}/search-summaries`, search) as Promise<
    PagedResult<SchoolCandidateInstitutionSummary>
  >;
};

export const getSchoolCandidateInstitutionSummaryListExport = async (
  search: SchoolCandidateInstitutionSummarySearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/summaries-export/${type}`,
    "post",
    search
  ) as Promise<any>;
};

export const saveSchoolCandidateInstitutionStatus = async (
  data: UpdateSchoolCandidateInstitutionStatus
) => {
  return api.post(`${apiUrlPrefix}/save-status`, data) as Promise<number>;
};

export const saveSchoolCandidateInstitutionCountyAssignment = async (
  data: UpdateSchoolCandidateInstitutionCountyAssignment
) => {
  return api.post(`${apiUrlPrefix}/save-reassignment`, data) as Promise<
    SaveResult<number>
  >;
};

export const getSchoolCandidateListExport = async (
  search: SchoolCandidateSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/export/${type}`,
    "post",
    search
  ) as Promise<any>;
};

export const getSchoolCandidateInstitutionAdminListExport = async (
  search: SchoolCandidateInstitutionAdminSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/institution-admin-export/${type}`,
    "post",
    search
  ) as Promise<any>;
};

export const setInstitutionAssignment = async (
  saveSchoolCandidateInstitutionAssignment: SaveSchoolCandidateInstitutionAssignment
) => {
  return api.post(
    `${apiUrlPrefix}/set-assignment`,
    saveSchoolCandidateInstitutionAssignment
  ) as Promise<SaveResult<SaveSchoolCandidateInstitutionAssignment>>;
};

export const getSchoolCandidateDepartmentProgram = async (
  departmentScheduleSearch: DepartmentScheduleSearch
) => {
  return api.post(
    `${apiUrlPrefix}/departments-programs-search`,
    departmentScheduleSearch
  ) as Promise<SchoolCandidateDepartmentProgram>;
};

export const dataSynchronization = async (data: SyncDataRequest) => {
  return api.post(`${apiUrlPrefix}/syncData`, data) as Promise<
    SaveResult<SyncDataRequest>
  >;
};

export const getSchoolCandidateRemark = async (
  schoolCandidateId: number,
  remarkTypeId: SchoolCandidateRemarkType
) => {
  return api.get(
    `${apiUrlPrefix}/remarks/${schoolCandidateId}/${remarkTypeId}`
  ) as Promise<SchoolCandidateRemark[]>;
};

export const saveSchoolCandidateRemark = async (
  schoolCandidateId: number,
  schoolCandidateRemarkTypeId: SchoolCandidateRemarkType,
  remark: string
) => {
  return api.post(`${apiUrlPrefix}/save-remark`, {
    schoolCandidateId,
    schoolCandidateRemarkTypeId,
    remark,
  }) as Promise<SaveResult<string>>;
};

export const updateRequestsProgramAndDepartment = async (
  data: SyncDataRequest
) => {
  return api.put(`${apiUrlPrefix}/request-department-program`, data) as Promise<
    SaveResult<SyncDataRequest>
  >;
};
